import { Component } from '@angular/core';
import { AddSubProductForm } from "../../../../components/admin-dashboard-component/product-details/product-sub-products/add-sub-product-form/add-sub-product-form";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-add-sub-product',
  imports: [AddSubProductForm],
  templateUrl: './add-sub-product.html',
  styleUrl: './add-sub-product.scss'
})
export class AddSubProduct {

  productId: number | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    const id = this.route.snapshot.params['id'];
    this.productId = id ? +id : null;
  }

}
